/**
 * Progress Page
 *
 * Unified page combining Map of Knowledge and Personal Stats.
 * Users can switch between visualizing their knowledge map and detailed statistics.
 */

import { useState } from "react";
import { MainLayout } from "@/components/layout/MainLayout";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Map, TrendingUp } from "lucide-react";
import { MapOfKnowledgeTab } from "@/components/progress/MapOfKnowledgeTab";
import { PersonalStatsTab } from "@/components/progress/PersonalStatsTab";

type MainTab = "map" | "stats";

export function ProgressPage() {
  const [activeTab, setActiveTab] = useState<MainTab>("map");

  return (
    <MainLayout
      title="Your Progress"
      subtitle="Track your learning journey and visualize your mastery"
    >
      <div className="container mx-auto p-4 md:p-6 max-w-7xl">
        <Tabs
          value={activeTab}
          onValueChange={(value) => setActiveTab(value as MainTab)}
          className="space-y-6"
        >
          <TabsList className="grid w-full max-w-md mx-auto grid-cols-2">
            <TabsTrigger value="map" className="gap-2">
              <Map className="w-4 h-4" />
              Map of Knowledge
            </TabsTrigger>
            <TabsTrigger value="stats" className="gap-2">
              <TrendingUp className="w-4 h-4" />
              Statistics
            </TabsTrigger>
          </TabsList>

          <TabsContent value="map" className="space-y-6">
            <MapOfKnowledgeTab />
          </TabsContent>

          <TabsContent value="stats" className="space-y-6">
            <PersonalStatsTab />
          </TabsContent>
        </Tabs>
      </div>
    </MainLayout>
  );
}
